var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tooltip",
    {
      attrs: {
        content: "Copy to clipboard",
        effect: "light",
        placement: "top",
      },
    },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "clipboard",
              rawName: "v-clipboard:copy",
              value: _vm.value,
              expression: "value",
              arg: "copy",
            },
            {
              name: "clipboard",
              rawName: "v-clipboard:success",
              value: _vm.onCopy,
              expression: "onCopy",
              arg: "success",
            },
            {
              name: "clipboard",
              rawName: "v-clipboard:error",
              value: _vm.onError,
              expression: "onError",
              arg: "error",
            },
          ],
          staticClass: "cursor-pointer",
        },
        [
          _vm._t("default", function () {
            return [_c("i", { staticClass: "far fa-copy" })]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }